import http from '../config/httpConfig';

export default {

    getPublishList(){
        return http.get('view/publish/webzine');
    },

    getWebZine(mode, webzine_id){
        return http.get(`view/${mode}/webzine/${webzine_id}`);
    },

    getArticleContent(mode, article_id){
        return http.get(`view/${mode}/webzine/article/${article_id}`);
    },

    subscribe(email){
        return http.post(`view/publish/webzine/subscribe/${email}`);
    },
    getCategoryList(){
        return http.get('view/publish/category');
    },

    getArticleList(param){

        const query = [];
        Object.keys(param).forEach(key => {
            query.push(key+'='+param[key]);
        });

        const queryStr = query.join("&")
        return http.get(`view/publish/category/article?${queryStr}`);
    }
}
